<!--
 * @FilePath: /daren-html-source/src/views/Help/index.vue
 * @Description: 帮助中心
-->

<template>
  <div class="memberRebate min-height">
    <div class="mTop">
      <div
        v-for="item in topData"
        :key="item.id"
        class="mTopBtn"
        :class="{ 
            act: topActive == item.id
        }"
        @click="topClick(item.id)"
        >{{ item.name }}</div
      >
    </div>
    <div :class="{
        'memberContent':true,
        'memberRebateNone':isNone
      }">
      <FmpTab v-show="topActive == 0"></FmpTab>
      <ShortLink v-show="topActive == 11 && $store.state.userInfo?.switchs?.short_url_switch == 1"></ShortLink>
      <discountTab v-show="topActive == 1"></discountTab>
      <RebateTab v-show="topActive == 2 && $store.state.userInfo.referral_program_switch == 0"></RebateTab>
      <Expand v-show="topActive == 2 && $store.state.userInfo.referral_program_switch == 1"></Expand>
      <contactCustTab :mubieData="mubieData" @goNote="goNote" v-show="topActive == 4 && !isNone"></contactCustTab>
      <contactDetail @customEvent="handleCustomEvent" :isDisplay="isDisplay" :detailId="detailId" v-if="topActive == 4 && isNone"></contactDetail>
    </div>
  </div>
</template>

<script>
import FmpTab from "./fmp.vue";
import ShortLink from "./ShortLink.vue";
import discountTab from "./discountCode.vue";
import RebateTab from "./rebate.vue";
import Expand from "./expand.vue";

import contactCustTab from "./contactCust.vue";
import contactDetail from "./otherHelp/index.vue";
import { getQuestionsV2 } from '@/utils/apiList/user'
export default {
  components: {
    FmpTab,
    discountTab,
    RebateTab,
    Expand,
    contactCustTab,
    contactDetail,
    ShortLink,
  },
  data() {
    return {
      topActive: 0,
      isNone:false,
      isDisplay:0,
      detailId:'',
      mubieData: null
    };
  },
  computed: {
    topData() {
      const userInfo = this.$store.state.userInfo || {};
      const referralProgramEnabled = userInfo.referral_program_switch == 1;
      const shortswitch = userInfo?.switchs?.short_url_switch == 1;

      return [
        { id: 0, name: this.$t('help.FEEMOO') },
        // 根据shortswitch值动态添加短链菜单项
        ...(shortswitch
          ? [
              { id: 11, name: this.$t('help.ShortLink') },
            ]
        : []),
        { id: 1, name: this.$t('help.CouponCode') },
        // 动态菜单项
        ...(referralProgramEnabled ? [
          { id: 2, name: this.$t('exPand.referralProgram')},
        ] : [
          { id: 2, name: this.$t('help.DownlineRebate') },
        ]),
        // { id: 3, name: this.$t('help.ComplaintBox') },
        { id: 4, name: this.$t('help.ContactCustomer')},
      ];
    }
  },
  mounted(){
    if (this.$route.query.id) {
        this.topActive = Number(this.$route.query.id) || 0;
        this.$router.replace({ query: {} });
    }
    if (this.$route.query.isHis) {
      this.goNote(2)
      this.$router.replace({ query: {} });
    }
    if (this.$route.query.tag) {
      this.topActive = Number(this.$route.query.tag) || 0;
      // this.$router.replace({ query: {} });
    } else {
      this.$router.replace({ query: {tag: this.topActive} });
    }
  },
  //提前加载联系客服数据,防止页面抖动
  async beforeRouteEnter(to, from, next) {
    const res = await getQuestionsV2(); // 加载子组件数据
    if(res.status == 1){
      next(vm => vm.mubieData = res.data.list);
    }
  },
  methods: {
    handleCustomEvent() {
      this.isNone = false
      this.isDisplay = 0
      this.topActive = 4
    },
    goNote(row,id){
      this.isNone = true
      this.isDisplay = row
      this.detailId = id
      this.topActive = 4
    },
    topClick(id) {
      if (id == 3) {
        window.open(`https://jinshuju.net/f/eykqQ2`, "_blank");
        return;
      }
      this.$router.replace({ query: {tag: id} });
      this.isNone = false
      this.topActive = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.memberRebate {
  background: #f7f7f7;

  .memberContent {
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 32px 24px;
    min-height: calc(100vh - 50px - 20px - 30px - 36px - 18px);
  }
}
.memberRebateNone{
  padding-top: 0 !important;
}
</style>
